import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';
import api from '../services/api';

export default function ShortLinkRedirect() {
    const { code } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        async function resolveAndRedirect() {
            try {
                const res = await api.get(`/short-links/resolve/${code}`);
                if (res.data?.targetUrl) {
                    let url = res.data.targetUrl;
                    if (res.data.referralCode) {
                        const sep = url.includes('?') ? '&' : '?';
                        url = `${url}${sep}ref=${res.data.referralCode}`;
                        // Set cookie for registration to pick up (30-day expiry)
                        document.cookie = `referralCode=${encodeURIComponent(res.data.referralCode)};path=/;max-age=${30 * 24 * 60 * 60};SameSite=Lax`;
                    }
                    window.location.href = url;
                } else {
                    setError('Link not found.');
                }
            } catch (err) {
                setError(err.response?.data?.error || 'This link could not be resolved.');
            }
        }
        resolveAndRedirect();
    }, [code]);

    if (error) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: 2 }}>
                <Typography variant="h6" color="error">{error}</Typography>
                <Typography variant="body2" color="text.secondary">
                    <a href="/" style={{ color: 'inherit' }}>Go to ReaderFLEX</a>
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
            <CircularProgress />
        </Box>
    );
}
